import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {LocalDate} from '../../../../../../lib/util/dates';
import {NgbDatePickerParserFormatter} from '../../../../../../util/ngb-datepicker';
import {Models} from '../../../../../../util/model-utils';
import {StockIntakeSupplierType} from "../../../../../../util/stock/stock-utils";
import {
  CustomerRecordMultiselectItem,
  CustomerRecordMultiselectProvider
} from "../../../../../../lib/customer/customer-record-multiselect-provider.service";
import {Angular2Multiselects} from "../../../../../../util/multiselect";

@Component({
  selector: 'app-form-record-stock-intake-header-dialog',
  templateUrl: './form-record-stock-intake-header-dialog.component.html',
  styleUrls: ['./form-record-stock-intake-header-dialog.component.scss']
})
export class FormRecordStockIntakeHeaderDialogComponent implements OnInit {

  StockIntakeSupplierType = StockIntakeSupplierType;

  model: FormRecordStockIntakeHeaderDialogModel = new FormRecordStockIntakeHeaderDialogModel();

  readonly: boolean = false;
  suppliers: CustomerRecordMultiselectItem[];

  supplierDropdownSettings: Angular2Multiselects.Settings = Angular2Multiselects.REMOTE_SINGLE_SELECT;

  constructor(private dateParser: NgbDatePickerParserFormatter,
              private customerRecordMultiselectProvider: CustomerRecordMultiselectProvider,
              public dialogRef: MatDialogRef<FormRecordStockIntakeHeaderDialogComponent, FormRecordStockIntakeHeaderDialogData>,
              @Inject(MAT_DIALOG_DATA) public data: FormRecordStockIntakeHeaderDialogData) {
    this.readonly = data.readonly === undefined ? this.readonly : data.readonly;
    this.model = new FormRecordStockIntakeHeaderDialogModel();
    this.model.intakeDate = dateParser.fromLocalDate(data.intakeDate);
    this.model.shippingNumber = data.shippingNumber;
    this.model.shippingCompany = data.shippingCompany;
    if (data.supplierCustomerRecordId) {
      this.customerRecordMultiselectProvider.getById(data.supplierCustomerRecordId).subscribe(res => {
        this.model.supplierCustomerRecord = [res];
      });
    }
    this.model.invoiceNumber = data.invoiceNumber;
  }

  ngOnInit(): void {
  }

  public static openDialog(
    dialog: MatDialog,
    data: FormRecordStockIntakeHeaderDialogData,
    resultCallback: (r: FormRecordStockIntakeHeaderDialogData | undefined) => void) {
    const dialogRef = dialog.open(FormRecordStockIntakeHeaderDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result?: FormRecordStockIntakeHeaderDialogData) => {
      resultCallback(result);
    });
  }


  onSupplierSearch(q?: string) {
    if (this.data.supplierCustomerId && this.data.supplierCustomerId > 0) {
      this.customerRecordMultiselectProvider.loadActiveForType(this.data.supplierCustomerId, q)
        .subscribe(res => {
          this.suppliers = res;
        });
    }
  }

  closeDialog(modified: boolean) {
    this.dialogRef.close(modified && !this.readonly ? this.toData() : undefined);
  }

  private toData(): FormRecordStockIntakeHeaderDialogData {
    return {
      intakeDate: Models.ngbDateToLocalDate(this.model.intakeDate),
      shippingNumber: this.model.shippingNumber,
      shippingCompany: this.data.supplierType === StockIntakeSupplierType.TEXT || !this.model.supplierCustomerRecordId
        ? this.model.shippingCompany : '',
      invoiceNumber: this.model.invoiceNumber,
      supplierCustomerRecordId: this.model.supplierCustomerRecordId
    }
  }
}

export interface FormRecordStockIntakeHeaderDialogData {
  readonly?: boolean;
  intakeDate?: LocalDate;
  shippingNumber: string;
  shippingCompany: string;
  invoiceNumber: string;
  supplierCustomerRecordId?: number;
  supplierType?: StockIntakeSupplierType;
  supplierCustomerId?: number;
}

class FormRecordStockIntakeHeaderDialogModel {
  intakeDate: NgbDateStruct | null = null;
  shippingNumber: string = '';
  shippingCompany: string = '';
  invoiceNumber: string = '';
  supplierCustomerRecord: CustomerRecordMultiselectItem[] = [];

  get supplierCustomerRecordId(): number | undefined {
    return this.supplierCustomerRecord.length === 0 ? undefined : this.supplierCustomerRecord[0].id;
  }

  get intakeDateString(): string {
    return Models.ngbDateToLocalDate(this.intakeDate).toIsoString();
  }
}
